// src/components/AccountPendingBanner.tsx
import React from 'react';
import { useUser } from '../../contextManager/user.context';
import { styled } from '../../styles/stitches.config';

const BannerDiv = styled('div', {
  width: '100%',
  padding: '0.75rem 1rem',
  backgroundColor: '$blue2',
  border: '1px solid $blue7',
  borderRadius: '0.5rem',
//   marginBottom: '1rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.75rem',
  fontSize: '0.875rem',
  color: '$blue11',
  flexWrap: 'wrap',
});


export const AccountPendingBanner: React.FC = () => {
  const { userDetails } = useUser();

  // Only show for tutors who have completed their profile but aren't account-verified yet
  if (!userDetails) return null;
  if (userDetails.role !== 'tutor') return null;
  if (userDetails.account_verified) return null;
  if (!userDetails.isProfileComplete) return null;

  return (
    <BannerDiv>
      Your profile is complete and under review. You'll appear in search results once approved.
    </BannerDiv>
  );
};